import { useEffect, useState } from "react";
// import firebase from "firebase/compat/app";
// import * as firebase from "firebase/app";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

import {
  collection,
  query,
  orderBy,
  onSnapshot,
  getDocs,
  addDoc,
} from "firebase/firestore";
import { db } from "../data/firebase";

export function useFetchData() {
  const [scores, setScores] = useState<any>([]);

  useEffect(() => {
    const q = query(collection(db, "scores"), orderBy("points", "desc"));
    onSnapshot(q, (querySnapshot) => {
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        data: doc.data(),
      }));

      setScores(data);
    });
  }, []);

  return [scores];
}

export const postData = ({ name, points }: any) => {
  const scoresRef = collection(db, "scores");
  return addDoc(scoresRef, {
    name,
    points,
    date: serverTimestamp(),
  });
};
